import { Routes, Route } from 'react-router-dom';
import { RequireAuth } from './auth/RequireAuth';
import { SimpleAuthProvider } from './auth/SimpleAuthProvider';
import HomePage from './pages/HomePage';
import QuizPage from './pages/QuizPage';
import ResultsPage from './pages/ResultsPage';
import DashboardPage from './pages/DashboardPage';
import HistoricoDetailPage from './pages/HistoricoDetailPage';
import HistoricoPage from './pages/HistoricoPage';

import AdminLayout from './layouts/AdminLayout';
import AdminLoginPage from './pages/Admin/LoginPage';
import AdminDashboardPage from './pages/Admin/DashboardPage';
import HomepageEditor from './pages/Admin/HomepageEditor';
import QuizEditor from './pages/Admin/QuizEditor';
import ResultsEditor from './pages/Admin/ResultsEditor';
import CoursesEditor from './pages/Admin/CoursesEditor';

import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <>
      <Routes>
        {/* --- ROTAS DE ADMINISTRAÇÃO (SEM KEYCLOAK) --- */}
        <Route path="/admin/login" element={<AdminLoginPage />} />

        {/* Rota pai para /admin com Layout */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboardPage />} />
          <Route path="dashboard" element={<AdminDashboardPage />} />
          <Route path="homepage" element={<HomepageEditor />} />
          <Route path="quiz" element={<QuizEditor />} />
          <Route path="results" element={<ResultsEditor />} />
          <Route path="courses" element={<CoursesEditor />} />
        </Route>

        {/* --- ROTAS PÚBLICAS/USUÁRIO (COM KEYCLOAK) --- */}
        <Route path="*" element={
          <SimpleAuthProvider>
            <Routes>
              <Route path="/" element={<HomePage />} />

              {/* Rotas protegidas */}
              <Route path="/quiz" element={<RequireAuth><QuizPage /></RequireAuth>} />
              <Route path="/results" element={<RequireAuth><ResultsPage /></RequireAuth>} />

              {/* Rota do Dashboard (sem autenticação) */}
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/historico" element={<HistoricoPage />} />
              <Route path="/historico/:id" element={<HistoricoDetailPage />} />

              {/* 404 para rotas não encontradas dentro do contexto de usuário */}
              <Route path="*" element={<div className="p-10 text-center"><h1>404 - Página não encontrada</h1></div>} />
            </Routes>
          </SimpleAuthProvider>
        } />
      </Routes>
      <Toaster />
    </>
  );
}

export default App;
